import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Collapse } from 'antd';
import * as ReactDOMServer from 'react-dom/server';

const AutoregressionStatistics = (props) => {
    const { Panel } = Collapse;

    let autoregData = '';

    if (props.getAnalysisRes?.autoregression) {
        autoregData = props.getAnalysisRes.autoregression;
    } else if (props.getAnalysisRes?.autoregressionx) {
        autoregData = props.getAnalysisRes.autoregressionx;
    } else if (props.getAnalysisRes?.regression) {
        autoregData = props.getAnalysisRes.regression;
    } else if (props.getAnalysisRes?.scatterplot) {
        autoregData = props.getAnalysisRes.scatterplot;
    }

    let autoregRows = [];

    for (let i = 0; i < Object.keys(autoregData.reg_stat).length; i++) {
        // console.log(Object.keys(data)[i])
        autoregRows.push(Object.values(autoregData.reg_stat)[i]);
    }

    // Statistics in cards

    // let newAutoregRows = autoregRows.map((item) => {
    //     let fixedValue = item.value;
    //     return (
    //         <Col
    //             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //             style={{ marginTop: 10 }}
    //         >
    //             <Card>
    //                 <Statistic
    //                     key={item.display_name}
    //                     title={item.display_name}
    //                     value={fixedValue}
    //                 />
    //             </Card>
    //         </Col>
    //     );
    // });

    // let statAutoregTable = (
    //     <>
    //         <div>
    //             <Row className="statistics-row-box" gutter={16}>
    //                 {newAutoregRows}
    //             </Row>
    //         </div>
    //     </>
    // );

    let newStatsAutoregRows2 = autoregRows.map((item) => {
        let fixedValue = item.value;
        return (
            <tr>
                <td className="title">{item.display_name}</td>
                <td className="value">{fixedValue}</td>
            </tr>
        );
    });

    let statAutoregTable2 = (
        <>
            <div key="12341">
                <div className="statistics-row-box">
                    <div className="table-box-fullproject-view">
                        <table className="table-table">
                            <tbody>{newStatsAutoregRows2}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    // AutoregStdResid

    let autoregStdResidHeaders = [];
    let autoregStdResidRows = [];

    for (let i = 0; i < Object.keys(autoregData.resid_stat).length; i++) {
        autoregStdResidHeaders.push(
            Object.keys(autoregData.resid_stat)[i].charAt(0).toUpperCase() +
                Object.keys(autoregData.resid_stat)[i].slice(1)
        );
    }

    for (let j = 0; j < Object.keys(autoregData.resid_stat).length; j++) {
        autoregStdResidRows.push(
            Object.values(autoregData.resid_stat)[j].toFixed(4)
        );
    }

    let newAutoregStdResidHeaders = autoregStdResidHeaders.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let newAutoregStdResidRows = autoregStdResidRows.map((item) => {
        return <td key={item}>{item}</td>;
    });

    let autoregStdResidRowsTable = (
        <>
            <div className="table-box-fullproject">
                <h3>Standardized Residuals</h3>
                <table className="table-regression first-row-bold">
                    <thead>
                        <tr>{newAutoregStdResidHeaders}</tr>
                    </thead>
                    <tbody>
                        <tr>{newAutoregStdResidRows}</tr>
                    </tbody>
                </table>
            </div>
        </>
    );

    // AutoregstdErrData

    let autoregStdErrHeaders = ['', 'Coeff', 'Std Error', 't-Stat', 'Vif'];

    let newAutoregStdErrHeaders = autoregStdErrHeaders.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let autoregDataRows = Object.values(autoregData.std_err);

    let autoregTableRows = [];

    for (let i = 0; i < autoregDataRows.length; i++) {
        let dr = autoregDataRows[i];

        let coeff = dr.coeff;
        let std_err = dr.std_err;
        let t_stat = dr.t_stat;
        let vif = typeof dr.vif == 'string' ? '-' : dr.vif;

        autoregTableRows.push(
            <tr>
                <td>{dr.display_name}</td>
                <td>{coeff}</td>
                <td>{std_err}</td>
                <td>{t_stat}</td>
                <td>{vif}</td>
            </tr>
        );
    }

    let autoregStdErrTable = (
        <>
            <div className="table-box-fullproject">
                <h3>Ordinary Std Error</h3>
                <table className="table-regression">
                    <thead>
                        <tr>{newAutoregStdErrHeaders}</tr>
                    </thead>
                    <tbody>{autoregTableRows}</tbody>
                </table>
            </div>
        </>
    );

    // autoregnwStdErr

    let autoregNwStdErrHeaders = ['', 'Coeff', 'std Error', 't-Stat', 'Vif'];

    let newAutoregNwStdErrHeaders = autoregNwStdErrHeaders.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let autoregNwDataRows = Object.values(autoregData.nw_std_err);

    let autoregNwTableRows = [];

    for (let i = 0; i < autoregNwDataRows.length; i++) {
        let dr = autoregNwDataRows[i];

        let coeff = dr.coeff;
        let std_err = dr.std_err;
        let t_stat = dr.t_stat;
        let vif = typeof dr.vif == 'string' ? '-' : dr.vif;

        autoregNwTableRows.push(
            <tr>
                <td>{dr.display_name}</td>
                <td>{coeff}</td>
                <td>{std_err}</td>
                <td>{t_stat}</td>
                <td>{vif}</td>
            </tr>
        );
    }

    let autoregNwStdErrTable = (
        <>
            <div className="table-box-fullproject">
                <h3>Newey-West Std Error</h3>
                <table className="table-regression">
                    <thead>
                        <tr>{newAutoregNwStdErrHeaders}</tr>
                    </thead>
                    <tbody>{autoregNwTableRows}</tbody>
                </table>
            </div>
        </>
    );

    let fullStats = (
        <div ref={props.forwardedRefStatistics}>
            {statAutoregTable2}
            {autoregStdResidRowsTable}
            {autoregStdErrTable}
            {autoregNwStdErrTable}
        </div>
    );

    let testtt = ReactDOMServer.renderToString(autoregNwStdErrTable);

    // let statistics = (
    //     <>
    //         <div>{statAutoregTable2}</div>
    //         <div>{autoregStdResidRowsTable}</div>
    //         <div>{autoregStdErrTable}</div>
    //         <div>{autoregNwStdErrTable}</div>
    //     </>
    // );

    return <>{fullStats}</>;
};

// export default React.memo(AutoregressionChart, (prevProps, nextProps) => {
//     return prevProps.x === nextProps.x
// });
export default React.memo(AutoregressionStatistics);
// export default AutoregressionChart;
